export default __webpack_public_path__ + "static/gw2-icon-community-d8921614b96ce62ff52f3bc22310a7fb.png";